module.exports = __webpack_public_path__ + "static/media/fail.ab0a2736.png";